import { createFileRoute } from "@tanstack/react-router";

import { LoadingIcon } from "@web-app/components";
import { useApp } from "@web-app/hooks";
import ChatEventsProvider from "@web-app/pages/chatPage/ChatEventsProvider";
import DashboardPage from "@web-app/pages/dashboardPage";

export const Route = createFileRoute("/analytics/$dashboardId")({
  component: Dashboard,
});

function Dashboard() {
  const { sessionUser, isLoading, logout } = useApp();
  const { dashboardId } = Route.useParams();

  if (isLoading || !sessionUser) {
    return (
      <div className="h-screen w-screen grid place-content-center">
        <LoadingIcon className="w-8 h-8" />
      </div>
    );
  }

  if (!sessionUser) {
    return <div>Not authenticated</div>;
  }

  return (
    <ChatEventsProvider>
      <DashboardPage dashboardId={dashboardId} logout={logout} />
    </ChatEventsProvider>
  );
}
